import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InformationalLoadingService {
  requests = 0;

  private requestingDataSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public requestingData$: Observable<string> = this.requestingDataSubject.asObservable();

  constructor() {}

  start(initMsg: string) {
    this.requests++;
    if (this.requests === 1) {
      setTimeout(() => {
        // weird after checked errors if not in timeout.
        this.requestingDataSubject.next(initMsg);
      });
    }
  }

  updateMessage(msg: string) {
    this.requestingDataSubject.next(msg);
  }

  stop() {
    this.requests--;
    if (this.requests === 0) {
      setTimeout(() => {
        // weird after checked errors if not in timeout.
        this.requestingDataSubject.next('');
      });
    }
  }
}
